import toaster, { Toast } from 'react-hot-toast';

import { CloseIcon, SlashCircle01Icon } from '@/assets/icons';
import { mergeClasses } from '@/utils';

import styles from './Alert.module.css';

interface ICustomErrorToast {
  message: string;
  t: Toast;
}

const ToastError: React.FC<ICustomErrorToast> = ({ message, t }: ICustomErrorToast) => {
  return (
    <div
      className={mergeClasses(
        'text-neutral-0 font-semibold text-body-sm min-w-[400px] max-w-[540px] flex items-center justify-between rounded-xs px-base !py-3 md:!py-4 bg-semantic-error-base dark:bg-red-dark gap-6',
        t.visible ? styles['animate-enter'] : styles['animate-leave'],
      )}
    >
      <div className="flex items-center gap-3">
        <SlashCircle01Icon className={mergeClasses('size-6')} />
        <div className={mergeClasses('break-normal', 'dark:!text-neutral-0')}>{message}</div>
      </div>
      <button onClick={() => toaster.dismiss(t.id)}>
        <CloseIcon className="size-6 dark:text-neutral-0" />
      </button>
    </div>
  );
};

export default ToastError;
